export default (blank) => {
  if (!blank) {
    return "Não informado";
  }

  return blank;
};
